"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var BellRinging = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2a8.003 8.003 0 0 0-7.617 5.549c-.247.766-.384 1.545-.501 2.265-.018.106-.034.21-.05.312-.1.619-.191 1.188-.33 1.746a16.704 16.704 0 0 1-1.266 3.42l-1.13 2.26A1 1 0 0 0 2 19h6a4 4 0 0 0 8 0h6a1 1 0 0 0 .894-1.447l-1.13-2.262a16.702 16.702 0 0 1-1.265-3.419c-.14-.558-.231-1.127-.33-1.746l-.05-.312c-.118-.72-.255-1.499-.502-2.265A8.003 8.003 0 0 0 12 2zM6.287 8.161a6.003 6.003 0 0 1 11.426 0c.197.611.315 1.26.431 1.974l.048.295c.098.614.204 1.278.366 1.927a18.703 18.703 0 0 0 1.417 3.829l.407.814H3.618l.407-.814a18.702 18.702 0 0 0 1.417-3.829c.162-.649.268-1.313.366-1.927l.048-.295c.116-.714.234-1.363.43-1.974zM14 19h-4a2 2 0 1 0 4 0z", fill: fill || 'currentColor' }),
        React.createElement("path", { d: "m20.816 3.56-.579-.816-1.631 1.157.578.816a8.755 8.755 0 0 1 1.252 2.568l.285.959 1.917-.57-.285-.96a10.76 10.76 0 0 0-1.537-3.154zM5.398 3.9l-.578.817a8.761 8.761 0 0 0-1.252 2.568l-.285.959-1.917-.57.286-.96c.34-1.142.864-2.205 1.536-3.154l.579-.816 1.631 1.157z", fill: fill || 'currentColor' })));
};
exports.default = BellRinging;
